import React from "react";
import HeroSection from "../components/HeroSection";
import FeaturesSection from "../components/FeaturesSection";
import HowItWorks from "../components/HowItWorks";
import WhyItMatters from "../components/WhyItMatters";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
  return (
    <div>
      <HeroSection />
      <FeaturesSection />
      <HowItWorks />
      <WhyItMatters />
      <FinalCTA />
    </div>
  );
}
